"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusGroup = void 0;
const gs = require("..");
const core_1 = require("../core");
class FocusGroup {
    constructor(wr, groupName = "noname", position = 0) {
        this._handlers = new Map();
        this._list = [];
        this.groupName = groupName;
        this.add(wr, position);
    }
    static AddItem(wr) {
        const fgData = wr.getGSA(FocusGroup.TagGSA);
        const parser = fgData.split(':');
        const fgName = parser[0];
        let position = 0;
        if (parser.length > 1)
            position = parseInt(parser[1]);
        if (!FocusGroup._Items.has(fgName))
            FocusGroup._Items.set(fgName, new FocusGroup(wr, fgName, position));
        else
            FocusGroup._Items.get(fgName).add(wr, position);
    }
    add(wr, position) {
        //If we have dublicate - clear list;
        if (this._list[position])
            this.clear();
        if (this._handlers.has(wr))
            this.remove(wr);
        wr.setGSA(FocusGroup.TagGSA, `${this.groupName}:${position}`);
        this._handlers.set(wr, new core_1.EventGSHandlerDisposable(wr, 'keyup', (e) => this._nextFocusHandler(e)));
        this._list[position] = wr;
        return true;
    }
    remove(wr) {
        const handler = this._handlers.get(wr);
        handler.dispose();
        this._handlers.delete(wr);
        gs.array.remove(this._list, wr);
    }
    clear() {
        for (const h of this._handlers.values())
            h.dispose();
        this._handlers.clear();
        gs.array.clear(this._list);
    }
    _nextFocusHandler(e) {
        if (e.keyCode !== 13)
            return;
        const wr = gs.w(e.target);
        if (!wr)
            return;
        if (!this._handlers.has(wr))
            return;
        const fgData = wr.getGSA(FocusGroup.TagGSA);
        const parser = fgData.split(':');
        const fgName = parser[0];
        if (this.groupName !== fgName) {
            this.remove(wr);
            return;
        }
        if (wr.el.nodeName === "TEXTAREA")
            if (!e.ctrlKey)
                return;
        for (let i = 0; i < this._list.length; i++)
            if (this._list[i] === wr) {
                const nextI = i + 1;
                if (nextI === this._list.length) {
                    wr.el.blur();
                    return;
                }
                else {
                    const nextWr = this._list[nextI];
                    if (!nextWr)
                        continue;
                    const nextEl = nextWr.el;
                    if (!nextEl.isConnected)
                        continue;
                    if (nextEl.getAttribute('type') === 'submit') {
                        nextEl.click();
                        return;
                    }
                    if (nextEl.nodeName) {
                        if (nextEl.nodeName === "INPUT")
                            nextEl.focus();
                        if (nextEl.nodeName === "TEXTAREA")
                            nextEl.focus();
                    }
                    if (nextEl.click) {
                        nextEl.click();
                        return;
                    }
                    nextEl.focus();
                    return;
                }
            }
    }
}
exports.FocusGroup = FocusGroup;
FocusGroup._Items = new Map();
FocusGroup.TagGSA = 'focus';
gs.WrapperGS.ImplementWrapperByGSA(FocusGroup.TagGSA, FocusGroup.AddItem);
//# sourceMappingURL=FocusGroup.js.map